import React, { useState, useEffect } from "react";
import HeaderAll from "../components/HeaderAll";
import Project from "../components/Project";
import Product from "../components/Product";
import { useStateValue } from "../Stateprovider";
import { Container, Row, Col, CardDeck } from "react-bootstrap";
import { db } from "../firebase";

function StoreFront() {
  const [{ user }, dispatch] = useStateValue();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    db.collection("projects").onSnapshot((snapshot) =>
      setProjects(
        snapshot.docs.map((doc) => ({
          docid: doc.id,
          data: doc.data(),
        }))
      )
    );
  }, []);

  return (
    <div>
      <HeaderAll></HeaderAll>
      <br></br>
      <center>
        <h1>Buy Projects</h1>
      </center>
      <br></br>
      <Container>
        <CardDeck className="mt-2">
          {projects?.map((project) => (
            <Product
              id={project.data.id}
              title={project.data.title}
              level={project.data.level}
              language={project.data.language}
              price={project.data.price}
              image={project.data.image}
              description={project.data.description}
            ></Product>
          ))}
        </CardDeck>
      </Container>
    </div>
  );
}

export default StoreFront;
